import { createContext, useContext, useMemo, useState } from "react";

import { useHasFloatingWindowOfType } from "src/base-components/FloatingWindow/hooks";

type SelectedRows = Record<string, boolean>;
type OnSelectRowHandler = (
  updaterOrValue: SelectedRows | ((rows: SelectedRows) => SelectedRows),
) => void;

const CasesTableContext = createContext<{
  selectedRows: SelectedRows;
  onSelectRow: OnSelectRowHandler;
  isSelectionDisabled: boolean;
}>({
  selectedRows: {},
  onSelectRow: () => {},
  isSelectionDisabled: false,
});

export const CasesTableProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({});
  const isSelectionDisabled = useHasFloatingWindowOfType("cm-bulk-action");

  const value = useMemo(
    () => ({
      selectedRows,
      onSelectRow: setSelectedRows,
      isSelectionDisabled,
    }),
    [selectedRows, isSelectionDisabled],
  );

  return (
    <CasesTableContext.Provider value={value}>
      {children}
    </CasesTableContext.Provider>
  );
};

export const useCasesTableContext = () => {
  const context = useContext(CasesTableContext);

  if (!context) {
    throw new Error(
      "useCasesTableContext can only be called within CasesTableContext",
    );
  }

  return context;
};
